// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3wq5U","alert":"SettungsInbox_alert__8IrJx"};